<template>
    <div class="equity-common-content">
        <div class="e-common-frames">
            <div class="e-top e-common-block">
                <div class="e-common-lr">
                    <div class="e-left">
                          <img src="@/assets/images/e-tjx-tsjc-icon@2x.png" alt="">
                    </div>
                    <div class="e-right">
                        <h3>贴身机场管家服务</h3>
                        <p>机场管家服务将为您提供机场全程管家陪同、贴心白金贵宾厅、代办乘机手续、绿色值机服务、快速安检通道等,一应俱全的机场服务,无限尊荣,遨您来体验！</p>
                    </div>
                </div>
            </div>
            <div class="e-bottom e-common-block">
                <h2>温馨提示</h2>
                <p class="bold">细则1</p>
                <p>钛金鑫卡持卡人全年尊享12次机场管家服务。</p>
                <p class="bold">细则2</p>
                <p>本行将在您激活人民币卡后的3个工作日内为您开通权益服务。</p>
                <p class="bold">细则3</p>
                <p>该权益仅限您本人使用,每次航班最多可携带3名亲友一并使用服务(2岁含以下婴童不计点次),您及您的亲友每人每次使用服务点数都将从您当年免费点次中扣除。</p>
                <p class="bold">细则4</p>
                <p>该权益覆盖范围包括上海浦东国际机场和上海虹桥国际机场,包含境内和境外航班(具体以预约时服务商实际提供的范围为准)。</p>
                <p class="bold">细则5</p>
                <p>根据服务商相关要求,您须在航班起飞前至少48小时(含)通过我行信用卡微信公众号权益平台预约服务；如您需要取消服务,请务必在服务提供前3小时通过微信公众号权益平台取消,否则视作您已使用本次服务,并扣减相应权益。</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>